import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import PayPalCheckout from './PayPalCheckout';
import { Navigate } from 'react-router-dom';
import { Container, Row, Col, Alert, Form } from "react-bootstrap";

export default function PaymentPage() {
  const { currentUser } = useAuth();
  const [agreed, setAgreed] = useState(false);

  if (currentUser?.profile?.ctg_course_paid) {
    return <Navigate to="/" replace />;
  }

  return (
    <Container className="my-5">
      <Row className="justify-content-center">
        <Col md={6}>
          <div className="text-center mb-4">
            <h5 className="font-weight-normal" style={{ fontSize: '1.25rem' }}>
              The registration fee for CTGWeb2.0 is $20.
              This registration fee is non-refundable.
            </h5>
          </div>
          <Alert variant="warning" className="text-dark mb-4" style={{ backgroundColor: '#fcf8e3', borderColor: '#faebcc' }}>
            Warning: If you check out using a PayPal account AND you choose bank transfer (AKA e-check), your payment may take 4-7 business days to complete per the <a href="https://www.paypal.com/us/webapps/mpp/ua/useragreement-full" target="_blank" rel="noopener noreferrer">PayPal User Agreement</a>. You will not be able to access the course until your payment is complete.
          </Alert>
          <div className="d-flex justify-content-center mb-4">
            <Form.Check
              type="checkbox"
              id="refund-agreement"
              label="Check this box to verify that you understand that the registration fee is non-refundable."
              checked={agreed}
              onChange={(e) => setAgreed(e.target.checked)}
              style={{ fontSize: '1.1rem' }}
            />
          </div>
          <div className="d-flex flex-column align-items-center">
            {agreed ? (
              <div className="w-100" style={{ maxWidth: "400px" }}>
                <PayPalCheckout />
              </div>
            ) : (
              <div className="text-muted text-center mt-3">
                <p>Please check the box above to reveal the payment buttons.</p>
              </div>
            )}
          </div>
        </Col>
      </Row>
    </Container>
  );
}
